import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import Tabs from '../../../../../../../features/components/Tabs'
import NamingConventionContent from './NamingConventionContent'
import CustomNameContent from './CustomNameContent'

import { CAMPAIGN_NAME_CONVENTION_OPTION, CAMPAIGN_NAME_OPTION, campaignNameOptions } from './fields'

import useDrawerFormStyles from '../../../../../../../styles/common/drawerForms'

const CampaignNameFields = ({ formik }) => {
  const { t } = useTranslation()
  const drawerFormClasses = useDrawerFormStyles()

  const { values, setFieldValue } = formik

  const selectCampaignNameTab = useCallback(
    value => {
      setFieldValue(CAMPAIGN_NAME_OPTION, value)
    },
    [setFieldValue]
  )

  return (
    <>
      <div className={drawerFormClasses.tabsContainer}>
        <h3 className={drawerFormClasses.sectionTitle}>{t('Campaign Name')}</h3>
        <Tabs
          options={campaignNameOptions}
          onSelectValue={selectCampaignNameTab}
          selectedValue={values[CAMPAIGN_NAME_OPTION]}
        />
      </div>
      {values[CAMPAIGN_NAME_OPTION] === CAMPAIGN_NAME_CONVENTION_OPTION ? (
        <NamingConventionContent formik={formik} />
      ) : (
        <CustomNameContent formik={formik} />
      )}
    </>
  )
}

export default CampaignNameFields
